import React, { useState } from 'react';
import { DimensionTableWrapper, DimensionTitle } from '../styled';
import { useSelector } from 'react-redux';
import { dimensionByTypesSelector } from '@store/common/dimensionList/selectors';
import { filterSelector } from '@store/common/selectors';
import AppDimensionTable from '../AppDimensionTable';
import { MAPPED_EVENT_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import { tid } from '@utils/test';
import {
  findDimensionDetailsInFilter,
  hasMappedEventName,
} from '@src/utils/filter/getDimensionTypesFromFilter';
import { TABLE_HEIGHT_MAPPING } from '../../header/Resize';

function MappedEventDimensionWidget() {
  const dimensionByTypes = useSelector(dimensionByTypesSelector);
  const filter = useSelector(filterSelector);
  const { dimensionTypes } = findDimensionDetailsInFilter(filter, dimensionByTypes);
  if (!hasMappedEventName(dimensionTypes)) {
    return null;
  }
  return (
    <>
      {MAPPED_EVENT_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);
  const dndStyle = {
    gridRow: `span ${gridRow}`,
  };
  return (
    <DimensionTableWrapper
      id={dimension}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DimensionTitle>{header}</DimensionTitle>
      <AppDimensionTable dimension={dimension} updateGrid={updateGrid} />
    </DimensionTableWrapper>
  );
};

export default MappedEventDimensionWidget;
